import React from 'react';
import __ from 'lodash';
 
class DropdownTingkatanPrestasi extends React.Component{

    componentWillMount(){
        console.log(this.props);
    }

    render(){
        return (
            this.props.tingkatan.map((val, i) =>
                <option key={i} value={val.tingkatan}>{val.tingkatan}</option>
            )            
        )
    }
}

export default DropdownTingkatanPrestasi;